import * as FileSaver from 'file-saver';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import autoTable from 'jspdf-autotable'
import { ExportPdf } from '@material-table/exporters';

const getFormattedTimeValue = (time) => {
  return ("0" + time).slice(-2);
};

export const timeConvertUtility = (scheduledTime = "") => {
  let offTime = "",
    onTime = "",
    time = "";
  if (scheduledTime) {
    const { off_time = "", on_time = "" } = scheduledTime;
    // off time
    if (off_time.hrs < 12) {
      offTime = `${getFormattedTimeValue((off_time.hrs === 0)?12:off_time.hrs)}:${getFormattedTimeValue(
        off_time.mins
      )} AM`;
    } else {
      offTime = `${getFormattedTimeValue(
        (off_time.hrs % 12) === 0 ? 12:off_time.hrs % 12
      )}:${getFormattedTimeValue(off_time.mins)} PM`;
    }
    // on time
    if (on_time.hrs < 12) {
      onTime = `${getFormattedTimeValue((on_time.hrs === 0?12:on_time.hrs))}:${getFormattedTimeValue(
        on_time.mins
      )} AM`;
    } else {
      onTime = `${getFormattedTimeValue(
        (on_time.hrs % 12) === 0?12:on_time.hrs % 12
      )}:${getFormattedTimeValue(on_time.mins)} PM`;
    }
    time = ` ${onTime} - ${offTime}`;
  }
  return {
    onTime,
    offTime,
  };
};

export const timeDurationToTime = (duration) => {
  if (duration === undefined ||  duration === null) {
    return "";
  }
  const { hrs = 0, mins = 0 } = duration;
  let result = "";
  if (hrs < 12) {
    if (hrs == 0) {
      result = `${getFormattedTimeValue(12)}:${getFormattedTimeValue(mins)} AM`;
    } else {
      result = `${getFormattedTimeValue(hrs)}:${getFormattedTimeValue(mins)} AM`;
    }
    
  } else {
    if ((hrs % 12) == 0) {
      result = `${getFormattedTimeValue(12)}:${getFormattedTimeValue(mins)} PM`;
    } else {
      result = `${getFormattedTimeValue(hrs % 12)}:${getFormattedTimeValue(mins)} PM`;
    }
  }
  
  return result;
};

export const getDateString = (date=new Date()) => {
  var mm = date.getMonth() + 1; // getMonth() is zero-based
  var dd = date.getDate();
  var h = date.getHours();
  var m = date.getMinutes();
  var s = date.getSeconds();
  return [date.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd,
          (h>9 ? '' : '0') + h,
          (m>9 ? '' : '0') + m,
          (s>9 ? '' : '0') + s
         ].join('-');
}

export const getDateStringHHMMSS = (seconds = 0) => {

  if (isNaN(seconds)) {
    seconds = 0;
  }
  let result = new Date(seconds * 1000).toISOString().slice(11, 19);
  //console.log(result);// "00:10:00" (hh:mm:ss)
  return result;
}

export const getDateStringMMSS = (seconds = 0) => {
  if (isNaN(seconds)) {
    seconds = 0;
  }
  // if seconds are less than 1 hour and you only need mm:ss
  let result = new Date(seconds * 1000).toISOString().slice(14, 19);
  //console.log(result); // "10:00" (mm:ss)
  return result;
}

export const exportMaterialTableToExcel = (columns, csvData, fileName = 'table') => {
  var columnList = columns.filter(item=> item.export === undefined || item.export === true)
  var exportData = [];
  for (let csvDataItem of csvData) {
    var obj = {};
    for (let columnItem of columnList) {
      obj[columnItem.title] = columnItem.exportTransformer(csvDataItem);
    }
    exportData.push(obj);
      
  }

  console.log("\n\n\n\n Expoet data");
  console.log(JSON.stringify(columns));
  console.log(JSON.stringify(csvData));
  console.log(JSON.stringify(exportData));

  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], {type: fileType});
  FileSaver.saveAs(data, fileName + fileExtension);
}

export const exportMaterialTableToPDF = (columns, csvData,fileName='table', pageHeight=8, pageWidth=18) => {
  const fileExtension = '.pdf';
  var columnList = columns.filter(item=> item.export === undefined || item.export === true)
  var exportData = [];
  var headerData = [];
  for (let columnObjItem of columnList) {
    headerData.push(columnObjItem.title);
  }
  for (let csvDataItem of csvData) {
    var obj = [];
    for (let columnItem of columnList) {
      obj.push(columnItem.exportTransformer(csvDataItem));
    }
    exportData.push(obj);
  }

  const doc = new jsPDF({
      orientation: 'l', 
      unit: 'in', 
      format: [pageHeight, pageWidth]
  });

  autoTable(doc, {
    head: [headerData],
    body: exportData,
  });

  doc.save(`${fileName}${fileExtension}`);
}

export const format2Decimals = (str, decimalCount = 2) => {
  const decFac = Math.pow(10, decimalCount);
  const num = parseFloat(str);
  // return Math.round(num * decFac) / decFac;
  return parseInt(num * decFac) / decFac;
}